import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { baseInterceptor } from '@core/interceptors/base.interceptor';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { applicationHttpClientCreator, HttpService } from '@services/http.service';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { MessageService } from 'primeng/api';
import { routes } from './app.routes';
import { ToastService } from './services/toast.service';
import { MasterDataEffects } from './store/effects/master-data.effect';
import { rootReducers } from './store/store';
import { TranslationConfigModule } from './translate-config.module';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimationsAsync(),
        provideAngularSvgIcon(),
        provideHttpClient(withInterceptors([baseInterceptor])),
        {
            provide: HttpService,
            useFactory: applicationHttpClientCreator,
            deps: [HttpClient],
        },
        ToastService,
        MessageService,
        importProvidersFrom(TranslationConfigModule),
        provideStore(rootReducers),
        provideEffects(MasterDataEffects),
    ],
};
